interface ToolbarProps {
  signedIn: boolean;
  ready: boolean;
  picking: boolean;
  onTogglePicker: () => void;
  onOpenPanel: () => void;
  onHide: () => void;
}

export function Toolbar({
  signedIn,
  ready,
  picking,
  onTogglePicker,
  onOpenPanel,
  onHide,
}: ToolbarProps) {
  return (
    <div className="uin-toolbar">
      <button
        className="uin-toolbar-icon"
        title="UI Noter — open menu"
        onClick={onOpenPanel}
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
          <path
            d="M12 4l8 4-3 8-5-2-5 2-3-8 8-4z"
            fill="currentColor"
            opacity="0.9"
          />
        </svg>
      </button>

      {ready ? (
        <button
          className={'uin-toolbar-comment' + (picking ? ' picking' : '')}
          onClick={onTogglePicker}
          title={picking ? 'Cancel commenting (Esc)' : 'Drop a comment anywhere on the page'}
        >
          {picking ? 'Cancel' : '+ Comment'}
        </button>
      ) : signedIn ? (
        <button className="uin-toolbar-comment disabled" onClick={onOpenPanel}>
          Pick org…
        </button>
      ) : (
        <button className="uin-toolbar-comment" onClick={onOpenPanel}>
          Sign in
        </button>
      )}

      <button className="uin-toolbar-close" title="Hide UI Noter (⌘⇧E)" onClick={onHide}>
        ×
      </button>
    </div>
  );
}
